import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import saveAs from 'file-saver';
import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const Rendervoucher = () => {

const resturl=sessionStorage.getItem("RESTURL");
let customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [modal, setModal] = useState({open:false});
const navWpform = React.useRef();




const [tblvoucher, setTblvoucher] = useState([]);
const [arrayvoucher, setArrayvoucher] = useState([]);

const [resulttype, setResulttype] = useState({
	historyres: false
});


const [dowait, setDowait] = useState({on:false});

const [crit, setCrit] = useState({
	DOC_NO:''
	, DATE1: formatDate(subtractMonth(new Date(), 4))
	, DATE2: formatDate(new Date())
	, CUSTOMER: ''
	, OTHER_PARTY: ''
	});



const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if


if (sessionStorage.getItem("USERNAME")!="ajones"){
	navigate("/");
	return;
	}//end if
	
document.title =   "Vouchers";	

 },[]);



useEffect(() => {
	document.getElementsByName('DOC_NO')[0].focus();
	
 },[JSON.stringify(tblvoucher)]);


useEffect(() => {
	 
	 //console.log("tblvoucher: "+JSON.stringify(tblvoucher));
		
	
 },[JSON.stringify(tblvoucher)]);

 
useEffect(() => {
	 
	 if (arrayvoucher.length>0)
		writetblvoucher();
	else
		setTblvoucher([]);
	
 },[JSON.stringify(arrayvoucher)]);
 

function formatDate(pDate){
	//const d = new Date();
var yyyy = pDate.getFullYear();
var dd = ("0" + pDate.getDate()).slice(-2);
var mm = ("0" + (pDate.getMonth() + 1)).slice(-2);
const resDate = `${yyyy}-${mm}-${dd}`;
console.log("resDate: "+resDate);
return resDate;

}

function subtractMonth(date, months) {
  let d = date.getDate();
  date.setMonth(date.getMonth() - months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
}//end func 

async function tbldocumlist(e){

if (e)
	e.preventDefault();

let params = crit;
params.USERNAME=sessionStorage.getItem("USERNAME")

console.log("tbldocumlist: "+JSON.stringify(params));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
setTblvoucher([]);
  await fetch(resturl+'rarwpform/tbldocumlist',requestOptions)
      .then(res => res.json())
      .then(res => 	aftertbldocumlist(res) )
      .catch(err => console.log(err));

}//end func

function aftertbldocumlist(res){
	
	setResulttype({historyres:true});
	
if (!res.length){
	console.log("abort aftertbldocumlist for !res.length)")
	return;
	}
	
console.log('aftertbldocumlist, res.length: '+res.length);

let arrtemp=[];

res.map((col, index) => {
	let datas={};
	for(var attributename in col){
			const data=col[attributename];
			//console.log('attributename, data: '+attributename+", "+data);
			datas[attributename] = (data==null)?'':data;
		}//end for	

	arrtemp.push(datas);

});
//console.log('arrtemp: '+JSON.stringify(arrtemp));
setArrayvoucher(arrtemp);

/*
setArrayvoucher((prev)=>{
	return {...prev, arrtemp}
	});

*/

}//end func


function writetblvoucher(){
	//console.log('writetblvoucher: '+JSON.stringify(arrayvoucher));
let htmrows=[];	
	
	for (var index=0; index<arrayvoucher.length; index++){
		const col=arrayvoucher[index];
		const key="tblvchrs_"+index;
		const docNo=col['DOC_NO'];
		const downloadLink=<a href="#" className="nodecor" id={"link_"+index} onClick={(e)=>{insertdocumlist(e, col);}} ><img src='img/pdf.gif' border='0' />&nbsp;{docNo}</a>;
		
		const htmrow=<tr key={key} >
					<td align="right" >{index+1}</td>
					<td align="left" >{col['TRANS_DATE']}</td>
					<td align="left" >{downloadLink}</td>
					<td className="tlnrgt" >{col['AMOUNT']}</td>
					<td align="left" >{col['DATE_PAID']}</td>
					<td align="left" >{col['ACCT_DESCP_1']}</td>
					<td align="left" >{col['CUSTOMER']}</td>
					<td align="left" >{col['OTHER_PARTY']}</td>
					<td align="left" >{col['RV_COMMENT']}</td>
		</tr>;
		htmrows.push(htmrow);
	}//end if
	
setTblvoucher(htmrows);
	
}//end func



async function makevchrpdffile(e, doc){
	//e.preventDefault();

	e.target.style.visibility='hidden';
	
	let PAID_AMT=doc.PAID_AMT.toString().match(/[0-9].*/g);
	PAID_AMT=PAID_AMT.length?PAID_AMT[0]:PAID_AMT;
	
	let PAID_DATE=doc.PAID_DATE??"";
	
	const params={
		DOC_NO: doc.DOC_NO
		, PAID_AMT: PAID_AMT
		, PAID_DATE: PAID_DATE.toString().replaceAll('.','-').toUpperCase()
			};
	
	console.log("makevchrpdffile: "+JSON.stringify(params));
	const filename=doc.DOC_NO+".pdf";
	//const filename="RCP.pdf";

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,responseType: "blob"
	  ,body: JSON.stringify( params )
  };		


	await fetch(customspremurl+'rarvchrpdffile/makevchrpdffile',requestOptions)
	  .then(data => aftermakevchrpdffile(data, e, filename) )
      .catch(err => console.log(err));	

}//end func


async function aftermakevchrpdffile(res, e, filename){
	e.target.style.visibility='visible';
	
	const blob = await res.blob();
	saveAs(blob, filename);
	
}//end func

function handleChange(e){
	
	let {name, value}=e.target;
	
	
console.log("handleChange name: "+name+' '+value);

	setCrit((prev)=>{
		return {...prev, [name]:value}	
	});
	
}//end func

async function insertdocumlist(e, docum){
	
e.preventDefault();

if (resulttype.historyres==false){
	const doc={
		DOC_NO: docum.DOC_NO
		,PAID_DATE: docum.DATE_PAID
		,PAID_AMT: docum.AMOUNT
		
	};
	makevchrpdffile(e, doc);
	return;
	}//end if

docum.RV_COMMENT="";
docum.USERNAME=sessionStorage.getItem("USERNAME")??"";

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( docum )
  };		

  await fetch(resturl+'rarwpform/insertdocumlist',requestOptions)
      .then(res => res.json())
      .then(res => 	afterinsertdocumlist(e,docum,res) )
      .catch(err => console.log(err));

}//end func

function afterinsertdocumlist(e,docum,res){
	const doc={
		DOC_NO: docum.DOC_NO
		,PAID_DATE: docum.DATE_PAID
		,PAID_AMT: docum.AMOUNT
		
	};
	
	makevchrpdffile(e, doc);
	
}//end func


function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


async function searchdocum(e){
	e.preventDefault();
	
e.target.style.visibility='hidden';

const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( crit )
};		

setArrayvoucher([]);
setTblvoucher([]);

await fetch(customspremurl+'rarwptapp/searchdocum',requestOptions)
  .then(res => res.json())
  .then(res => 	aftersearchdocum(res, e) )
  .catch(err => console.log(err));	
	
}//end func	

function aftersearchdocum(res, e){
e.target.style.visibility='visible';

setResulttype({historyres:false});

setArrayvoucher(res);


/*
if (!res.length)
	return;

let htmrows=[];

	res.map((col, index) => {
		
		const key="tblvchrs_"+index;
		const docNo=col['DOC_NO'];
		const downloadLink=<a href="#" className="nodecor" id={"link_"+index} onClick={(e)=>{insertdocumlist(e, col);}} ><img src='img/pdf.gif' border='0' />&nbsp;{docNo}</a>;
		
		const htmrow=<tr key={key} >
		
					<td align="right" >{index+1}</td>
					<td align="left" >{col['TRANS_DATE']}</td>
					<td align="left" >{downloadLink}</td>
					<td className="tlnrgt" >{col['AMOUNT']}</td>
					<td align="left" >{col['DATE_PAID']}</td>
					<td align="left" >{col['ACCT_DESCP_1']}</td>
					<td align="left" >{col['CUSTOMER']}</td>
					<td align="left" >{col['OTHER_PARTY']}</td>
					<td align="left" >{col['RV_COMMENT']}</td>
					</tr>;
		htmrows.push(htmrow);
		
		});//end map
setTblvoucher(htmrows);
*/

}//end func


  return (
    <>
	
	<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >Vouchers</p>	
<form id="form1" method="POST" onSubmit={(e)=>{searchdocum(e);}} >	
<table align='center' width="45%" style={{marginTop:"10px", marginBottom:"10px"}} cellSpacing="0" cellPadding="0" >
<tbody>
	<tr>
	<td align='right' >Document #:&nbsp;</td>
	<td align='left' ><input name='DOC_NO' type="text"  value={crit.DOC_NO} onChange={(e)=>{handleChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} placeholder='Document #' /></td>
	</tr>
	<tr>
	<td align='right' >Start Date:&nbsp;</td>
	<td align='left' ><input name='DATE1' type="date" value={crit.DATE1} onChange={(e)=>{handleChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} placeholder='Start Date' /></td>
	</tr>
	<tr>
	<td align='right' >End Date:&nbsp;</td>
	<td align='left' ><input name='DATE2' type="date" value={crit.DATE2} onChange={(e)=>{handleChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} placeholder='End Date' /></td>
	</tr>
	<tr>
	<td align='right' >Customer Name:&nbsp;</td>
	<td align='left' ><input name='CUSTOMER' type="text" value={crit.CUSTOMER} onChange={(e)=>{handleChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} placeholder='Customer Name' /></td>
	</tr>
	<tr>
	<td align='right' >Altern. Names:&nbsp;</td>
	<td align='left' ><input name='OTHER_PARTY' type="text"  value={crit.OTHER_PARTY} onChange={(e)=>{handleChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} placeholder='Altern. Names' /></td>
	</tr>
	<tr>
	<td align='right' ></td>
	<td align='left' ><button className="button" >search</button></td>
	</tr>
	<tr>
	<td align='right' >Saved Docum's:&nbsp;</td>
	<td align='left' >
		<input  readOnly className="gnsbro" value={arrayvoucher.length} size="3" />
		&nbsp;&nbsp;<a href="#" onClick={(e)=>{tbldocumlist(e);}} >search in search history</a>
	</td>
	</tr>


</tbody>
</table>
</form>
	
	<table align='center' className='customers' style={{width:"75%"}} >
	<thead>
	<tr>
		<th>#</th>
		<th>CREATED</th>
		<th>DOC #</th>
		<th>AMOUNT</th>
		<th>DT PAID</th>
		<th>ACCOUNT</th>
		<th>CUSTOMER</th>
		<th>OTHER PARTY</th>
		<th>COMMENT</th>
	</tr>
	</thead>
	<tbody>
		{tblvoucher}
	</tbody>
	</table>



<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default Rendervoucher;